// stylesheets
// entry point for webpack
import './css/app.less' // for header / footer
import './css/pages/static.less'
import './css/pages/terms.less'
import './css/pages/unavailable.less'
import './css/widgets/profile_header.less'
